
import * as React from 'react'
import { Box } from "@mui/material"
import {formatPrice} from "@ui-seeker/utils"

import { HierarchicalTextBlock } from '@components'


export default function averagePricesColumn() {
	return {
		name: '', label: 'Avg Prices',
		options: {
			filter: false,
            setCellProps: () => ({ sx: { textAlign: "center", minWidth: 300 } }),
			customBodyRowRenderLite: (value, row) => {
                const currency = row.currency
                const config = { displayZero: true }

                return <Box sx={{ display: 'flex', flexDirection: 'column'}}>
                    <HierarchicalTextBlock title="Avg BB Price: " titleValue={formatPrice(row.avgBBPrice, currency, config)} />
                    <HierarchicalTextBlock title="Avg Price 1P: " titleValue={formatPrice(row.avg1PPrice, currency, config)} />
                    <HierarchicalTextBlock title="Avg BB Shipping Price: " titleValue={formatPrice(row.avgShippingPriceBB, currency, config )} />
                    <HierarchicalTextBlock title="Avg Shipping Price 1p: " titleValue={formatPrice(row.avgShippingPrice1P, currency, config)} />
                </Box>
            }
		}
		}
	}
